<template>
    <section id="datapersonil">
        <h4 class="title is-5">{{ actionTitle }} Paket</h4>
        <div class="rows">
            <div class="row">
                <b-button  class="button is-primary" 
                tag="router-link"
                to="/biro/berandapaket"
                icon-left="arrow-left-bold">Kembali</b-button>
            </div>
            <div class="row">
                <div class="box">
                    <section>
                        <b-field label="Nama Paket" horizontal>
                            <b-field custom-class="is-small has-text-danger" 
                            :type="form.nama_paket.type"
                            :message="form.nama_paket.message">
                                <b-input name="nama_paket" @input="clearError(form.nama_paket)" 
                                placeholder="Nama Paket" v-model="form.nama_paket.value" expanded></b-input>
                            </b-field>
                        </b-field>
                        <b-field label="Jenis Paket" horizontal>
                        <b-field  custom-class="is-small has-text-danger" 
                            :type="form.jenis_paket.type"
                            :message ="form.jenis_paket.message">
                            <b-select @input="clearError(form.jenis_paket)" 
                            v-model="form.jenis_paket.value" placeholder="Select one" expanded>
                                <option value="Standart">CT Dasar</option>
                                <option value="Lanjutan">CT Lanjutan</option>
                                <option value="Informatika">CT Informatika</option>
                            </b-select>
                            </b-field>
                        </b-field>

                        <!-- <b-field horizontal label="Target Guru Inti"
                        :type="form.jumlah_guru_inti.type"
                        :message="form.jumlah_guru_inti.message"
                        v-model="form.jumlah_guru_inti.value" >
                        <b-numberinput v-model="form.jumlah_guru_inti.value" @input="clearError(form.jumlah_guru_inti)" min="0"></b-numberinput>
                        </b-field>

                        <b-field horizontal label="Target Guru Sasaran"
                        :type="form.jumlah_guru_sasaran.type"
                        :message="form.jumlah_guru_sasaran.message"
                        v-model="form.jumlah_guru_sasaran.value" >
                        <b-numberinput v-model="form.jumlah_guru_sasaran.value" @input="clearError(form.jumlah_guru_sasaran)" min="0"></b-numberinput>
                        </b-field>

                        <b-field horizontal label="Target Jumlah Mentor"
                        :type="form.jumlah_mentor.type"
                        :message="form.jumlah_mentor.message"
                        v-model="form.jumlah_mentor.value" >
                        <b-numberinput v-model="form.jumlah_mentor.value" @input="clearError(form.jumlah_mentor)" min="0"></b-numberinput>
                        </b-field> -->

                         <!-- <b-field horizontal label="Target Minimum Siswa"
                        :type="form.minimum_siswa.type"
                        :message="form.minimum_siswa.message"
                        v-model="form.minimum_siswa.value" >
                        <b-numberinput v-model="form.minimum_siswa.value" @input="clearError(form.minimum_siswa)" min="0"></b-numberinput>
                        </b-field> -->
                        <b-field horizontal><!-- Label left empty for spacing -->
                            <p class="control">
                                <button class="button is-primary"
                                    @click="confirm()">
                                Simpan
                                </button>
                            </p>
                        </b-field>
                    </section>
                </div>
            </div>
        </div>
        <b-loading
            :is-full-page ="true"
            :active.sync="isLoading"
            :can-cancel="false">
        </b-loading>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                isLoading:false,
                actionTitle:'',
                editID:0,
                activeBiro: Object,
                dataPaket: new FormData(),
                editDataPaket:{},
                form:
                {
                    nama_paket:{
                       value:'', type:'', message:''
                   },
                    jenis_paket:{
                       value:'', type:'', message:''
                   },
                //    jumlah_guru_inti:{
                //        value:0, type:'', message:''
                //    },
                //    jumlah_guru_sasaran:{
                //         value:0, type:'', message:''
                //    },
                //    jumlah_mentor:{
                //        value:0, type:'', message:''
                //    },
                //     minimum_siswa:{
                //        value:0, type:'', message:''
                //    },
                //    nama_biro:{
                //         value:'', type:'', message:''
                //    }
                },
                snackbarMessage:'',
                pakets:[],
                config: {}

            }
        },
        methods:{
            getPaketByBiro()
            {
                var uri = this.$apiUrl + 'paket/biro/' + this.detailId 
                this.$http.get(uri, this.config).then(response=>
                {
                    this.pakets = response.data.value
                })
            },
            getData(editID)
            {
                var uri = this.$apiUrl + 'paket/' + editID
                 
                this.$http.get(uri, this.config).then(response=>{
                 this.editDataPaket= response.data.value
                 //console.log(this.editDataPersonil)
                 this.formEdit(this.editDataPaket)
                })
            },
            formEdit(dataPaket)
            {
                this.form.nama_paket.value = dataPaket.nama_paket
                this.form.jenis_paket.value = dataPaket.jenis_paket
                // this.form.jumlah_guru_inti.value = dataPaket.jumlah_guru_inti
                // this.form.jumlah_guru_sasaran.value = dataPaket.jumlah_guru_sasaran
                // this.form.jumlah_mentor.value = dataPaket.jumlah_mentor
                // this.form.minimum_siswa.value = dataPaket.minimum_siswa
               // this.form.nama_biro.value = dataPersonil.id_biro
            },
            clearError(form)
            {
                console.log(form)
                form.type = ''
                form.message = ''
            },
            checkData()
            {
                let count = 0
                
                if(this.form.nama_paket.value === "")
                {
                    this.form.nama_paket.type = 'is-danger'
                    this.form.nama_paket.message = "Nama paket harus di isi"
                    count ++
                }
                if(this.form.jenis_paket.value ==="")
                {
                    this.form.jenis_paket.type = 'is-danger'
                    this.form.jenis_paket.message ="Harus memilih salah satu jenis paket"
                    count ++
                }
                // if( this.form.minimum_siswa.value < 0) {
                //     this.form.minimum_siswa.type = 'is-danger'
                //     this.form.minimum_siswa.message = "Jumlah Minimum tidak bisa minus!"
                //     count++
                // }
                // if( this.form.jumlah_guru_inti.value < 0) {
                //     this.form.jumlah_guru_inti.type = 'is-danger'
                //     this.form.jumlah_guru_inti.message = "Jumlah Guru Inti tidak bisa minus!"
                //     count++
                // }
                // if( this.form.jumlah_guru_sasaran.value < 0) {
                //     this.form.jumlah_guru_sasaran.type = 'is-danger'
                //     this.form.jumlah_guru_sasaran.message = "Jumlah Guru Sasaran tidak bisa minus!"
                //     count++
                // }
                // if( this.form.jumlah_mentor.value < 0) {
                //     this.form.jumlah_mentor.type = 'is-danger'
                //     this.form.jumlah_mentor.message = "Jumlah Mentor tidak bisa minus!"
                //     count++
                // }

                
                if(count >0)
                return false
            },
            tambahData()
            {
                this.isLoading = true
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal...Silahkan input lagi", 'is-danger')
                    this.isLoading = false
                }else{
                    this.dataPaket.append("nama_paket",this.form.nama_paket.value)
                    this.dataPaket.append("jenis_paket",this.form.jenis_paket.value)
                    // this.dataPaket.append("jumlah_guru_inti",this.form.jumlah_guru_inti.value)
                    // this.dataPaket.append("jumlah_guru_sasaran",this.form.jumlah_guru_sasaran.value)
                    // this.dataPaket.append("jumlah_mentor",this.form.jumlah_mentor.value)
                    // this.dataPaket.append("minimum_siswa",this.form.minimum_siswa.value)
                  //  this.dataPersonil.append("id_biro",this.form.nama_biro.value)

                    var uri =this.$apiUrl + 'paket';
                    this.$http.post(uri,this.dataPaket,this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({ name :'BerandaPaket'})
                        this.snackbarMessage = response.data.message
                        this.snackbar("Berhasil Ditambahkan...Silahkan lihat detail",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Ditambahkan",'is-danger')
                        }else{
                            this.snackbar("Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
            },
            editData(editID)
            {
                this.isLoading = true
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal Diedit",'is-danger')
                    this.isLoading = false
                }else{
                    this.editDataPaket.jenis_paket = this.form.jenis_paket.value
                    this.editDataPaket.nama_paket = this.form.nama_paket.value
                    // this.editDataPaket.jumlah_guru_inti =this.form.jumlah_guru_inti.value
                    // this.editDataPaket.jumlah_guru_sasaran = this.form.jumlah_guru_sasaran.value
                    // this.editDataPaket.jumlah_mentor = this.form.jumlah_mentor.value
                    // this.editDataPaket.minimum_siswa = this.form.minimum_siswa.value
                  //  this.editDataPersonil.id_biro = this.form.nama_biro.value

                    console.log(editID)
                    console.log(this.editDataPaket)

                    var uri = this.$apiUrl + 'paket/' + editID;
                    this.$http.post(uri,this.editDataPaket,this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({name: 'BerandaPaket'})
                        this.snackbarMessage = response.data.message
                        this.snackbar("Data Berhasil Diedit",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Diedit",'is-danger')
                        }else{
                            this.snackbar("Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
            },
            confirm()
            {
                this.editID == 0? this.tambahData() : this.editData(this.editID)
            },
            snackbar(snackbarMessage,type)
            {
                this.$buefy.toast.open({
                    duration : 5000,
                    message: snackbarMessage,
                    type: type,
                    position: 'is-top',
                    actionText :'OK',
                    queue: false,
                })
            },
        },
        mounted()
        {
            if(this.$session.exists()){
                this.config = {
                    headers: {
                        'Authorization': 'Bearer ' + this.$session.get('token')
                    }
                }
            }
            this.activeBiro = this.$session.get('biro')
            if(this.activeBiro)
            {
            this.detailId = this.activeBiro.id_biro
            this.getPaketByBiro()
           // this.getDataByBiro(this.detailId)
            }
            if(this.$route.params.id)
            {
                this.editID = this.$route.params.id
                this.actionTitle = 'Ubah'
                console.log(this.editID)
                this.getData(this.editID)
            }else{
                this.actionTitle = 'Tambah'
            }
            // this.isLoading=false
        }
    }
</script>